export const FANDOM_CONSENT_UPDATE = "fandomConsentUpdate";

/**
 * Waits for the {@link window.fandomCmp} object to be ready and optionally checks if `allowed.ads` is set to true.
 * When it resolves, we can start processing ads consent-related logic.
 */
export const waitForConsent = (
  container: Window = window,
  withAllowedAds = true,
) => {
  const check = () =>
    container.fandomCmp !== undefined &&
    container.fandomCmp.ready &&
    (withAllowedAds ? container.fandomCmp.allowed?.ads : true);

  return new Promise<void>((resolve) => {
    if (check()) {
      return resolve();
    }

    const listener = () => {
      if (check()) {
        container.removeEventListener(FANDOM_CONSENT_UPDATE, listener);
        resolve();
      }
    };
    container.addEventListener(FANDOM_CONSENT_UPDATE, listener);
  });
};
